import { NgModule } from '@angular/core';
import { CommonModule, DatePipe } from '@angular/common';
import { TruncatePipe } from './pipes/truncate.pipe';
import { PhoneNumberFormatterPipe } from './pipes/phone-number-formatter.pipe';
import { TruncateDecimalPipe } from './pipes/truncate-decimal.pipe';
import { ApostrophePipe } from './pipes/apostrophe.pipe';
import { RemoveCountryPipe } from './pipes/remove-country.pipe';
import { ReplaceDateSeparatorPipe } from './pipes/replace-date-separator.pipe';
import { SearchPipe } from './pipes/search.pipe';
import { TruncateAfterNthPipe } from './pipes/truncate-after-nth.pipe';

@NgModule({
    declarations: [
        TruncatePipe,
        PhoneNumberFormatterPipe,
        TruncateDecimalPipe,
        ApostrophePipe,
        RemoveCountryPipe,
        ReplaceDateSeparatorPipe,
        SearchPipe,
        TruncateAfterNthPipe
    ],
    imports: [CommonModule],
    exports: [
        TruncatePipe,
        PhoneNumberFormatterPipe,
        TruncateDecimalPipe,
        ApostrophePipe,
        RemoveCountryPipe,
        ReplaceDateSeparatorPipe,
        SearchPipe,
        TruncateAfterNthPipe
    ],
    providers: [DatePipe]
})
export class AppSharedPipeModule {}
